import React, { useState, useEffect } from 'react';
import '../styles/Events.css';

// API endpoint - PHP API on esportslah.gg server
const EVENTS_API_URL = 'https://esportslah.gg/api/events.php?limit=10';

// Fallback sample events data
const SAMPLE_EVENTS = [
  {
    id: 1,
    name: 'CardsLah',
    date: '2026-01-30',
    location: 'LSH Sentul',
    url: 'https://waze.com/ul/hw286604pn'
  },
  {
    id: 2,
    name: 'Hoshi Digital Fest Vol.1',
    date: '2026-01-24',
    location: 'Rumah Tangsi',
    url: ''
  }
];

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await fetch(EVENTS_API_URL);

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data) {
            setEvents(data.data);
          } else {
            console.log('API returned error, using sample data');
            setEvents(SAMPLE_EVENTS);
          }
        } else {
          console.log('API not available, using sample data');
          setEvents(SAMPLE_EVENTS);
        }
      } catch (error) {
        console.log('Network error, using sample data:', error.message);
        setEvents(SAMPLE_EVENTS);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-MY', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const getEventStatus = (dateStr) => {
    const eventDate = new Date(dateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    eventDate.setHours(0, 0, 0, 0);

    const diffDays = Math.ceil((eventDate - today) / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'past';
    if (diffDays === 0) return 'today';
    if (diffDays <= 7) return 'soon';
    return 'upcoming';
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'today': return 'TODAY!';
      case 'soon': return 'THIS WEEK';
      case 'past': return 'ENDED';
      default: return 'UPCOMING';
    }
  };

  return (
    <section id="events" className="events-section">
      <div className="section-header">
        <div className="comic-panel-border">
          <h2 className="section-title">
            <span className="title-text">UPCOMING EVENTS</span>
            <span className="title-burst">!</span>
          </h2>
          <p className="section-subtitle">
            Join us at these exciting TCG events across Malaysia
          </p>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Loading events...</p>
        </div>
      ) : (
        <div className="events-grid">
          {events.map((event) => {
            const status = getEventStatus(event.date);
            return (
              <div key={event.id} className={`event-card ${status}`}>
                <div className="event-card-inner">
                  <div className="event-badge">
                    <span className={`status ${status}`}>
                      {getStatusLabel(status)}
                    </span>
                  </div>

                  <div className="event-type-icon">
                    <div className="icon-cards">
                      <div className="icon-pokeball"></div>
                    </div>
                  </div>

                  <h3 className="event-title">{event.name}</h3>

                  <div className="event-details">
                    <div className="detail-item">
                      <span className="detail-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM5 7V6h14v1H5z"/>
                        </svg>
                      </span>
                      <span className="detail-text">{formatDate(event.date)}</span>
                    </div>

                    <div className="detail-item">
                      <span className="detail-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                        </svg>
                      </span>
                      <span className="detail-text">{event.location}</span>
                    </div>
                  </div>

                  {event.url ? (
                    <a
                      href={event.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="event-cta"
                    >
                      <span className="btn-text">GET DIRECTIONS</span>
                      <span className="btn-burst">!</span>
                    </a>
                  ) : (
                    <button className="event-cta" disabled={status === 'past'}>
                      <span className="btn-text">
                        {status === 'past' ? 'EVENT ENDED' : 'COMING SOON'}
                      </span>
                      <span className="btn-burst">!</span>
                    </button>
                  )}

                  <div className="event-speed-lines"></div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {events.length === 0 && !loading && (
        <div className="no-events">
          <p>No upcoming events at the moment. Check back soon!</p>
        </div>
      )}

      <div className="events-decoration">
        <div className="action-lines"></div>
      </div>
    </section>
  );
};

export default Events;
